module.exports = __webpack_public_path__ + "static/media/216-Uebergabe_ID_27.89c1bd9b.mp3";